import translationsFr from './translationsFr';

function customTranslate(template, replacements) {
  replacements = replacements || {};

  // Translate
  template = translationsFr[template] || template;

  // Replace
  return template.replace(/{([^}]+)}/g, function(_, key) {
    return replacements[key] || '{' + key + '}';
  });
}

customTranslate.currentLanguage = 'fr';

export default customTranslate;